

export class ClientSessionVerifierDataService {
    public static serviceName = 'clientSessionVerifierDataService';

    public static readonly ROUTE = '/session/verify';


    /*@ngInject*/
    constructor(private Restangular: Restangular.IService) {
    }


    public async verify(botDetectionResult: BotDetectionResult): Promise<void> {
        return this.Restangular
            .all(ClientSessionVerifierDataService.ROUTE)
            .post(null, botDetectionResult);
    }

}

type BotDetectionResult = {bot: true; botKind: string;} | {bot: false;};